/* eslint-disable */
/**
 * SagFunnelBIPanel.jsx - Sag-Funnel med konverteringsrater
 * Endpoint: GET /api/os/bi/sag-funnel
 */
import React, { useState, useEffect, useCallback } from 'react';

function fmtPct(a, b) {
  if (!b || b === 0) return null;
  return Math.round((a / b) * 100);
}

export default function SagFunnelBIPanel() {
  const [data, setData] = useState(null);
  const [fejl, setFejl] = useState(null);
  const [loader, setLoader] = useState(true);

  const hent = useCallback(async () => {
    try {
      const r = await fetch('/api/os/bi/sag-funnel', { credentials: 'include' });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      const d = await r.json();
      setData(d);
      setFejl(null);
    } catch (err) {
      setFejl(err.message);
    } finally {
      setLoader(false);
    }
  }, []);

  useEffect(() => { hent(); }, [hent]);

  const etager = data ? [
    { label: 'Beregner-sessioner', sublabel: '(seneste 30d)', antal: data.beregner_sessioner_30d, farve: '#3b82f6', bredde: 100 },
    { label: 'Klienter oprettet', sublabel: '(seneste 90d)', antal: data.klienter_oprettet_90d, farve: '#2563eb', bredde: 72 },
    { label: 'Aktive sager', sublabel: '(nu)', antal: data.aktive_sager, farve: '#1d4ed8', bredde: 52 },
    { label: 'Afsluttede sager', sublabel: '(12 mdr)', antal: data.afsluttede_sager_12m, farve: '#1e3a8a', bredde: 36 },
  ] : [];

  return (
    <div style={{ width: '100%' }}>
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: '#e2e8f0' }}>Sag-Funnel</div>
        <div style={{ fontSize: 13, color: '#7a8fa6', marginTop: 3 }}>
          Fra beregner-session til afsluttet sag
        </div>
      </div>

      {loader && <div style={{ textAlign: 'center', padding: 40, color: '#7a8fa6' }}>Henter...</div>}
      {fejl && !loader && (
        <div style={{
          background: 'rgba(239,68,68,0.10)', border: '1px solid rgba(239,68,68,0.25)',
          borderRadius: 8, padding: '12px 16px', color: '#f87171', fontSize: 13,
        }}>Fejl: {fejl}</div>
      )}

      {!loader && !fejl && data && (
        <div style={{ width: '100%', maxWidth: 560, margin: '0 auto' }}>
          {etager.map((etage, idx) => {
            const naeste = etager[idx + 1];
            const konvPct = naeste ? fmtPct(naeste.antal, etage.antal) : null;
            return (
              <React.Fragment key={idx}>
                <div style={{
                  width: etage.bredde + '%',
                  margin: '0 auto',
                  background: etage.farve,
                  borderRadius: idx === 0 ? '10px 10px 0 0' : idx === etager.length - 1 ? '0 0 10px 10px' : 0,
                  padding: '14px 20px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: 6,
                  minHeight: 54,
                }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: '#fff' }}>{etage.label}</div>
                    <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)' }}>{etage.sublabel}</div>
                  </div>
                  <div style={{ fontSize: 22, fontWeight: 800, color: '#fff' }}>
                    {etage.antal != null ? etage.antal.toLocaleString('da-DK') : '—'}
                  </div>
                </div>
                {konvPct !== null && (
                  <div style={{
                    width: '100%', textAlign: 'center', padding: '6px 0',
                    fontSize: 12, color: '#7a8fa6',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                  }}>
                    <span style={{ color: 'rgba(255,255,255,0.15)', fontSize: 18 }}>&#9660;</span>
                    <span style={{
                      background: 'rgba(59,130,246,0.12)', border: '1px solid rgba(59,130,246,0.25)',
                      borderRadius: 6, padding: '2px 10px', fontWeight: 700,
                      color: konvPct > 20 ? '#22c55e' : konvPct > 10 ? '#f59e0b' : '#f87171',
                    }}>
                      {konvPct}% konvertering
                    </span>
                    <span style={{ color: 'rgba(255,255,255,0.15)', fontSize: 18 }}>&#9660;</span>
                  </div>
                )}
              </React.Fragment>
            );
          })}

          <div style={{ marginTop: 20, display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
            <div style={{
              background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: 8, padding: '8px 16px', textAlign: 'center',
            }}>
              <div style={{ fontSize: 11, color: '#7a8fa6', textTransform: 'uppercase', letterSpacing: 0.5 }}>Total sager (12 mdr)</div>
              <div style={{ fontSize: 20, fontWeight: 700, color: '#e2e8f0' }}>{data.total_sager_12m}</div>
            </div>
            <div style={{
              background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: 8, padding: '8px 16px', textAlign: 'center',
            }}>
              <div style={{ fontSize: 11, color: '#7a8fa6', textTransform: 'uppercase', letterSpacing: 0.5 }}>Aktiv rate</div>
              <div style={{ fontSize: 20, fontWeight: 700, color: '#3b82f6' }}>
                {fmtPct(data.aktive_sager, data.total_sager_12m)}%
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
